import { ModuleFE_OrderGroup } from './ModuleFE_OrderGroup.js';
export const ModulePackFE_OrderGroupDB = [ModuleFE_OrderGroup];
//# sourceMappingURL=module-pack.js.map